<template>
  <div class="row">
    <div class="col mt-2 mt-md-4 mt-5 pt-md-1">
      <div class="">
        <div class="row">
          <div class="col-12">
            <h2 class="mb-md-0 pt-md-3 commission_title pb-4">
              Комисcия по категориям
            </h2>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-8">
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-between justify-content-md-center align-items-end">
                  <div class="d-block d-md-none mobile-title">
                    WEB-offer *
                  </div>
                  <img
                    class="image"
                    src="../../assets/images/MacBookPro.png"
                    alt="MacBookPro"
                  >
                </div>
              </div>
            </div>

            <div class="row d-none d-md-flex">
              <div class="col-12">
                <div class="title">
                  WEB-offer *
                </div>
              </div>
            </div>

            <div class="row d-none d-md-flex">
              <div class="col-12 col-md-4 mt-md-2">
                <div class="ml-md-1">
                  <h2 class="h2 green_color">
                    6,5%
                  </h2>
                  <ul class="pitem list-unstyled pt-md-2">
                    <li>Хранение</li>
                    <li>Кухни</li>
                    <li>Краски (Лакокрасочные материалы)</li>
                    <li>Освещение</li>
                    <li>Плитка</li>
                    <li>Напольные покрытия</li>
                    <li>Отделочные материалы (Декор)</li>
                  </ul>
                </div>
              </div>
              <div class="col-12 col-md-4 pl-md-3 mt-md-2 pr-md-0">
                <div class="pl-2 ml-md-1">
                  <h2 class="h2 green_color">
                    3,5%
                  </h2>
                  <ul class="pitem list-unstyled pt-md-2">
                    <li>Скобяные изделия</li>
                    <li>Водоснабжение</li>
                    <li>Сантехника</li>
                    <li>Столярные изделия</li>
                    <li>Сад (Дача и сад)</li>
                    <li>Новогодние товары</li>
                  </ul>
                </div>
              </div>
              <div class="col-12 col-md-4 pl-md-0 mt-md-2">
                <div class="pl-2">
                  <h2 class="h2 green_color">
                    1,25%
                  </h2>
                  <ul class="pitem list-unstyled pt-md-2">
                    <li>Электротовары</li>
                    <li>Инструменты</li>
                    <li>Стройматериалы</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="col-3 offset-1 d-none d-md-block android-block">
            <div class="d-flex justify-content-center">
              <img
                src="../../assets/images/mobile.png"
                alt="mobile"
                class="mobile-image"
              >
            </div>
            <div class="title">
              АРР-offer **
            </div>
            <h2 class="h2 green_color mt-2">
              4%
            </h2>
            <div class="text">
              Единая комиссия для всех категорий товаров
            </div>
          </div>
        </div>

        <div class="row mt-2 d-flex d-sm-block d-md-none mb-3">
          <div class="col-12">
            <b-tabs class="commission">
              <b-tab
                title="6,5%"
                active
              >
                <ul class="pitem list-unstyled">
                  <li>Хранение</li>
                  <li>Кухни</li>
                  <li>Краски (Лакокрасочные материалы)</li>
                  <li>Освещение</li>
                  <li>Плитка</li>
                  <li>Напольные покрытия</li>
                  <li>Отделочные материалы (Декор)</li>
                </ul>
              </b-tab>
              <b-tab title="3,5%">
                <ul class="pitem list-unstyled">
                  <li>Скобяные изделия</li>
                  <li>Водоснабжение</li>
                  <li>Сантехника</li>
                  <li>Столярные изделия</li>
                  <li>Сад (Дача и сад)</li>
                  <li>Новогодние товары</li>
                </ul>
              </b-tab>
              <b-tab title="1,25%">
                <ul class="pitem list-unstyled">
                  <li>Электротовары</li>
                  <li>Инструменты</li>
                  <li>Стройматериалы</li>
                </ul>
              </b-tab>
            </b-tabs>
          </div>
        </div>

        <div class="row d-block d-md-none">
          <div class="col-12">
            <div class="mobile-title">
              АРР-offer **
            </div>
            <div class="d-flex justify-content-between align-items-top">
              <div class="d-flex commissions w-100 align-items-center">
                <div class="percent">
                  4%
                </div>
                <div>Единая комиссия для всех категорий</div>
              </div>
              <img
                src="../../assets/images/mobile2.png"
                alt="mobile"
                class="mobile-image--on-mobile"
              >
            </div>
          </div>
        </div>

        <div class="commission_help pt-md-3 mb-3 mb-md-0">
          * Кроме акционных товаров с пометкой «Лучшая цена», ставка по которым составляет 0,1%. За покупку товаров с
          пометкой «Только онлайн» комиссия не начисляется.
        </div>
        <div class="commission_help pt-md-3 mb-3 mb-md-0">
          ** Если покупатель установит мобильное приложение по размещённой вами ссылке и купит товар, вы получите
          комиссию по ставке 4 %.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LandingCommission',
};
</script>

<style scoped lang="scss">
.h2 {
  font-size: 45px !important;
}
.image {
  max-width: 502px;
  margin-bottom: 7px;
  @media (max-width: 768px) {
    max-width: 113px;
  }
}
.title {
  font-size: 20px;
  line-height: 26px;
  color: #BF8900;
  padding-bottom: 5px;
  border-bottom: 4px solid #FDC300;
}
.mobile-image {
  max-width: 110px;
  width: 100%;
  height: auto;
  margin-bottom: 16px;
  @media (max-width: 768px) {
    max-width: 25px;
    margin-bottom: 0;
  }
}
.android-block {
  margin-top: 96px;
  @media (max-width: 991px) {
    margin-top: 68px;
  }
  @media (max-width: 768px) {
    margin-top: 0;
  }
}
.mobile-image--on-mobile {
  max-width: 31px;
  margin-left: 16px;
  height: auto;
  width: 100%;
  align-self: start;
  margin-top: 14px;
  @media (max-width: 465px) {
    height: 72px;
    width: auto;
    max-width: 100%;
  }
}
.commissions {
  border: 1px solid #21282B;
  background-color: #FDC300;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 13px 24px;
  margin-bottom: 16px;
  margin-top: 14px;
}
.percent {
  font-size: 28px;
  line-height: 30px;
  font-weight: bold;
  color: #21282B;
  margin-right: 16px;
}
.mobile-title {
  font-size: 16px;
  line-height: 22px;
  color: #21282B;
  letter-spacing: 0.05px;
}
</style>
